// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// modules
// views
import { nothing } from '$func/utils'
import { sendAnalytics } from '$logic/analytics'

window.analiteWithRetry = nothing

window.analite = (type, data, wappId, wisId) => {
  sendAnalytics({
    type,
    ts: new Date(),
    ...(data && { payload: data }),
    ...(wappId && { wappId }),
    ...(wisId && { wisId }),
  })
}
declare global {
  // eslint-disable-next-line no-var,vars-on-top
  var analite: (
    type: string,
    data?: Record<string, any>,
    wappId?: string,
    wisId?: string,
  ) => void
}
